import { NgModule } from '@angular/core';
import { DeferRenderingDirective } from './defer-rendering.directive';

@NgModule({
  declarations: [DeferRenderingDirective],
  exports: [DeferRenderingDirective],
})
export class DeferRenderingModule {}
